<template>
    <div class="container-action-button" v-if="params.data">
        <BaseButton class="small-button green-button" buttonText="" @click="onCustomerSpindleStats()" title="Parc de broches">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'chart-line']"/>
            </template>
        </BaseButton>
        <BaseButton @click="onEditContacts" buttonText="" title="Consulter les contacts">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'address-book']" />
            </template>
        </BaseButton>
        <BaseButton v-if="this.params.data.blocked === false" @click="onBlockOrUnblockCustomer" buttonText="" title="Bloquer le client">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'lock']" />
            </template>
        </BaseButton>
        <BaseButton v-if="this.params.data.blocked === true" @click="onBlockOrUnblockCustomer" buttonText="" title="Débloquer le client">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'unlock']" />
            </template>
        </BaseButton>
        <BaseButton v-if="this.params.data.deleted === false" @click="onDeleteOrEnableCustomer" buttonText="" title="Supprimer le client">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'trash']" />
            </template>
        </BaseButton>
        <BaseButton v-if="this.params.data.deleted === true" @click="onDeleteOrEnableCustomer" buttonText="" title="Restaurer le client">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'trash-restore']" />
            </template>
        </BaseButton>
    </div>
</template>

<script>
    import BaseButton from '../../components/Base/BaseButton.vue';
    import * as Vue from "vue";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    export default {
        name: 'ListCustomersActionButtonsRenderer',
        components: {
            BaseButton: Vue.shallowRef(BaseButton),
            FontAwesomeIcon: Vue.shallowRef(FontAwesomeIcon)
        },
        methods: {
            onDeleteOrEnableCustomer() {
                this.params.context.componentParent.deleteOrEnableCustomer(this.params.data);
            },
            onEditCustomer() {
                this.params.context.componentParent.displayEditCustomerModal(this.params.data);
            },
            onEditContacts() {
                this.params.context.componentParent.displayEditContactsModal(this.params.data);
            },
            onHistory() {
            
            },
            onCustomerSpindleStats() {
                this.params.context.componentParent.openCustomerSpindleStatsModal(this.params.data.id);
            },
            onBlockOrUnblockCustomer() {
                this.params.context.componentParent.openBlockOrUnblockModel(this.params.data.id, this.params.data.blocked, this.params.data.blockingComment);
            }
        }
    }        
</script>